import { useQuery } from '@apollo/client';
import { GET_INFLUENCER } from '../../api/graphql/query';
import auth from '../../components/auth';

export const useCustomizations = (influencerId?: string | null) => {
  const givenInfluencerId = influencerId
    ? parseInt(influencerId)
    : (auth.getUser()?.influencerId ?? null);

  const { data, loading, error } = useQuery(GET_INFLUENCER, {
    variables: { id: givenInfluencerId },
    skip: !givenInfluencerId,
  });

  return {
    isLoading: loading,
    error,
    customizations: data
      ? data.creator?.customizations
      : {
          isNewVideo: false,
          isVideoLibraryEnabled: false,
          canUsePromotionDetails: false,
          canUsePromotions: false,
        },
  };
};
